export const FETCHING_TWC_WARRANTIES = '@@toyota/FETCHING_TWC_WARRANTIES';
export const FETCHED_TWC_WARRANTIES = '@@toyota/FETCHED_TWC_WARRANTIES';
export const FETCHED_TWC_WARRANTIES_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_FAILED';

export const FETCHING_TWC_WARRANTIES_STATUS = '@@toyota/FETCHING_TWC_WARRANTIES_STATUS';
export const FETCHED_TWC_WARRANTIES_STATUS = '@@toyota/FETCHED_TWC_WARRANTIES_STATUS';
export const FETCHED_TWC_WARRANTIES_STATUS_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_STATUS_FAILED';

export const ADDING_TWC_WARRANTIES = '@@toyota/ADDING_TWC_WARRANTIES';
export const ADDED_TWC_WARRANTIES = '@@toyota/ADDED_TWC_WARRANTIES';
export const ADDED_TWC_WARRANTIES_FAILED = '@@toyota/ADDED_TWC_WARRANTIES_FAILED';


export const ADDING_TWC_WARRANTIES_ATTACHMENTS = '@@toyota/ADDING_TWC_WARRANTIES_ATTACHMENTS';
export const ADDED_TWC_WARRANTIES_ATTACHMENTS = '@@toyota/ADDED_TWC_WARRANTIES_ATTACHMENTS';
export const ADDED_TWC_WARRANTIES_ATTACHMENTS_FAILED = '@@toyota/ADDED_TWC_WARRANTIES_FAILED';

export const FETCHING_TWC_WARRANTIES_JOB = '@@toyota/FETCHING_TWC_WARRANTIES_JOB';
export const FETCHED_TWC_WARRANTIES_JOB = '@@toyota/FETCHED_TWC_WARRANTIES_JOB';
export const FETCHED_TWC_WARRANTIES_JOB_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_JOB_FAILED';

export const FETCHING_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH = '@@toyota/FETCHING_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH';
export const FETCHED_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH = '@@toyota/FETCHED_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH';
export const FETCHED_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH_FAILED =
  '@@toyota/FETCHED_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH_FAILED';

export const FETCHING_TWC_WARRANTIES_SUBCONTRACT_LIST = '@@toyota/FETCHING_TWC_WARRANTIES_SUBCONTRACT_LIST';
export const FETCHED_TWC_WARRANTIES_SUBCONTRACT_LIST = '@@toyota/FETCHED_TWC_WARRANTIES_SUBCONTRACT_LIST';
export const FETCHED_TWC_WARRANTIES_SUBCONTRACT_LIST_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_SUBCONTRACT_LIST_FAILED';


export const FETCHING_TWC_WARRANTIES_PART = '@@toyota/FETCHING_TWC_WARRANTIES_PART';
export const FETCHED_TWC_WARRANTIES_PART = '@@toyota/FETCHED_TWC_WARRANTIES_PART';
export const FETCHED_TWC_WARRANTIES_PART_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_PART_FAILED';
export const FETCHING_TWC_WARRANTIES_PARTS_BY_SEARCH = '@@toyota/FETCHING_TWC_WARRANTIES_PARTS_BY_SEARCH';
export const FETCHED_TWC_WARRANTIES_PARTS_BY_SEARCH = '@@toyota/FETCHED_TWC_WARRANTIES_PARTS_BY_SEARCH';
export const FETCHED_TWC_WARRANTIES_PARTS_BY_SEARCH_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_PARTS_BY_SEARCH_FAILED';

export const FETCHING_TWC_WARRANTIES_BY_ID = '@@toyota/FETCHING_TWC_WARRANTIES_BY_ID';
export const FETCHED_TWC_WARRANTIES_BY_ID = '@@toyota/FETCHED_TWC_WARRANTIES_BY_ID';
export const FETCHED_TWC_WARRANTIES_BY_ID_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_BY_ID_FAILED';

export const CLEAR_WARRANTY = '@@toyota/CLEAR_WARRANTY';
export const CLEAR_WARRANTIES = '@@toyota/CLEAR_WARRANTIES';
export const CLEAR_SEARCH_PART_WARRANTY = '@@toyota/CLEAR_SEARCH_PART_WARRANTY';
export const CLEAR_WARRANTY_CHASSIS = '@@toyota/CLEAR_WARRANTY_CHASSIS';
export const CLEAR_ADDED_WARRANTY = '@@toyota/CLEAR_ADDED_WARRANTY';
export const CLEAR_UPDATE_WARRANTY = '@@toyota/CLEAR_UPDATE_WARRANTY';

export const FETCHING_TWC_WARRANTY_ATTACHMENTS = '@@toyota/FETCHING_TWC_WARRANTY_ATTACHMENTS ';
export const FETCHED_TWC_WARRANTY_ATTACHMENTS = '@@toyota/FETCHED_TWC_WARRANTY_ATTACHMENTS ';
export const FETCHED_TWC_WARRANTY_ATTACHMENTS_FAILED = '@@toyota/FETCHED_TWC_WARRANTY_ATTACHMENTS_FAILED';

export const UPDATING_TWC_WARRANTIES = '@@toyota/UPDATING_TWC_WARRANTIES';
export const UPDATED_TWC_WARRANTIES = '@@toyota/UPDATED_TWC_WARRANTIES';
export const UPDATED_TWC_WARRANTIES_FAILED = '@@toyota/UPDATED_TWC_WARRANTIES_FAILED';

export const FETCHING_TWC_WARRANTY_CHASSIS = '@@toyota/FETCHING_TWC_WARRANTY_CHASSIS';
export const FETCHED_TWC_WARRANTY_CHASSIS = '@@toyota/FETCHED_TWC_WARRANTY_CHASSIS';
export const FETCHED_TWC_WARRANTY_CHASSIS_FAILED = '@@toyota/FETCHED_TWC_WARRANTY_CHASSIS_FAILED';

export const ADDING_TWC_WARRANTY_CHASSIS = '@@toyota/ADDING_TWC_WARRANTY_CHASSIS';
export const ADDED_TWC_WARRANTY_CHASSIS = '@@toyota/ADDED_TWC_WARRANTY_CHASSIS';
export const ADDED_TWC_WARRANTY_CHASSIS_FAILED = '@@toyota/ADDED_TWC_WARRANTY_CHASSIS_FAILED';

export const FETCHING_TWC_AGENCIES = '@@toyota/FETCHING_TWC_AGENCIES';
export const FETCHED_TWC_AGENCIES = '@@toyota/FETCHED_TWC_AGENCIES';
export const FETCHED_TWC_AGENCIES_FAILED = '@@toyota/FETCHED_TWC_AGENCIES_FAILED';
